// extracted by mini-css-extract-plugin
export default {"summaryModel":"Expences_summaryModel__OkWAa","showSummryModel":"Expences_showSummryModel__5hnt1","summaryBody":"Expences_summaryBody__ccK1U","modelHead":"Expences_modelHead__aE1g-"};